import { GeoPoint } from "../../earth/core/geoPoint";
import { FrameTime } from "../../earth/earthEngine";
import { EarthEngine } from "../../earth/earthEngine";
import { Country } from "../../earth/model/country";
import { Land } from "../../earth/model/land";
import { Main } from "../main";
import { PieChartManager } from "./pieChartManager";
import { UIContext } from "./uiContext";
import { UIContextCanTimeout } from "./uiContextCanTimeout";
import { UIContextDetails } from "./uiContextDetails";
import { UIContextNavigation } from "./uiContextNavigation";
import { UIManager } from "./uiManager";

export class UIContextLandDetails extends UIContextCanTimeout {
    _onMoveId = -1;

    constructor(public land: Land) {
        super();
    }

    enter(from: UIContext) {
        super.enter(from);
        this._onMoveId = EarthEngine.instance.camera.onMove.connect(() => { this.shouldSwitchToContext.emit(new UIContextNavigation()); });
        if (Main.instance.uiManager.pieChartManager) {
            Main.instance.uiManager.pieChartManager.parentFilter = this.land;
        }
    }

    leave(to: UIContext) {
        super.leave(to);
        if (this._onMoveId >= 0) {
            EarthEngine.instance.camera.onMove.disconnect(this._onMoveId);
            this._onMoveId = -1;
        }
        if (Main.instance.uiManager.pieChartManager) {
            Main.instance.uiManager.pieChartManager.parentFilter = null;
        }
    }

    onEarthTapped(country: Country | null) {
        super.onEarthTapped(country);
        if (country) {
            this.shouldSwitchToContext.emit(new UIContextDetails(country));
        }
    }

    onSkyTapped() {
        super.onSkyTapped();
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/ui/uiContextLandDetails.tsx